import React from 'react';

import P from '@hero/ui-kit/typography/P';

import DotSignifier from '../../../components/DotSignifier';
import { checkText } from '../constants';
import * as Style from '../style.module.scss';
import { ReadinessCheck } from '../types';

const FailedChecks: React.FC<{ checks: ReadinessCheck[] }> = ({ checks }) => {
    // Several checks can fail for one cause (no run yet); each sentence is shown once.
    const lines = Array.from(
        new Set(checks.filter((check) => !check.passed).map((check) => checkText(check)))
    );

    return (
        <div className={Style.failedChecks}>
            {lines.map((line) => (
                <div key={line} className={Style.failedCheck}>
                    <DotSignifier type="fail" />
                    <P noDefaultMargin>{line}</P>
                </div>
            ))}
        </div>
    );
};

export default FailedChecks;
